import { cellCfgAttrsBaseSchema, cellCfgBaseSchema } from './cell-base.zod';
import z from 'zod';

export const markdownCellSchema = cellCfgBaseSchema.extend({
    type: z.literal('markdown'),
    attrs: cellCfgAttrsBaseSchema.extend({
        content: z.string(),
    }),
    modifiers: z.record(z.enum([
        'content',
    ]), z.string().optional()).optional(),
});
